"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import Link from "next/link";
import { Package } from "lucide-react";

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    const token =
      typeof window !== "undefined" ? localStorage.getItem("token") : null;
    if (token) {
      router.replace("/assets");
    }
  }, [router]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[var(--background)] p-6 sm:p-8">
      <main className="flex w-full max-w-md flex-col items-center gap-8 text-center">
        <div className="flex size-20 items-center justify-center rounded-2xl bg-[var(--primary)]/10 text-[var(--primary)]">
          <Package className="size-10" />
        </div>
        <div className="space-y-2">
          <h1 className="text-2xl font-semibold text-[var(--foreground)] sm:text-3xl">
            Asset Management
          </h1>
          <p className="text-[var(--muted)]">ระบบจัดการสินทรัพย์</p>
        </div>
        <Link
          href="/login"
          className="inline-flex items-center justify-center rounded-xl bg-[var(--primary)] px-8 py-3.5 text-sm font-semibold text-[var(--primary-foreground)] transition-colors hover:bg-[var(--primary-hover)]"
        >
          เข้าสู่ระบบ
        </Link>
      </main>
    </div>
  );
}
